var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgX({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0001 3.00012C16.9706 3.00018 21.0001 7.02966 21.0001 12.0001C21.0001 16.9705 16.9705 21.0001 12.0001 21.0001C7.02966 21.0001 3.00018 16.9706 3.00012 12.0001C3.00012 7.02962 7.02962 3.00012 12.0001 3.00012ZM6.59973 7.04993L10.6671 12.4562L6.81555 16.9503H8.4718L11.4581 13.4865L14.0675 16.9503H17.3995L13.1534 11.2511L16.7882 7.04993H15.1329L12.3722 10.214L10.0157 7.04993H6.59973ZM9.53333 8.00012L15.4708 15.964H14.5529L8.547 8.00012H9.53333Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default __webpack_public_path__ + "static/media/x.33fd94f8e4622ec92362848f2dcc0d86.svg";
export { ForwardRef as ReactComponent };